import { ProtectedImg } from '../../utils/protectedFile';
import {useEffect, useState} from 'react';
import { searchOnEnter } from '../../components/searchOnEnter';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctors, doctorDeActivate, doctorActivate } from '../../actions/adminActions';
import { Link } from 'react-router-dom';
import { useAlert } from 'react-alert';
import Pagination from 'react-js-pagination';
import { Table, Modal, DropdownButton, Dropdown } from 'react-bootstrap';
import adminImg from '../../assets/Images/defaultUser.png';
import { HIDE_ALERT_MESSAGE } from '../../constants/Common';
import { Prod01 } from '../../constants/ActionType';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';

const DOCTOR_SORT_COLUMNS = {
    name: { type: 'name', value: personName },
    gender: { type: 'string', value: (d) => d?.gender },
    npi: { type: 'number', value: (d) => d?.npinumber },
    phone: { type: 'string', value: (d) => d?.phone1 },
    status: { type: 'boolean', value: (d) => d?.block },
};


const DoctorsList = () => {

    const dispatch = useDispatch();

    const alert = useAlert();
    const [currentPage, setCurrentPage] = useState(1);
    const [resPerPage, setResPerPage] = useState(10);

    const [smShow, setSmShow] = useState(false); //small confirm modal
    const [doctorModel, setDoctorModel] = useState(null);
    const [doctorToDelete, setDoctorToDelete] = useState(null);
    const [doctorIsBlocked, setDoctorIsBlocked] = useState(false);
    const [query, setQuery] = useState("");
    const keys = ["firstname", "lastname", "email", "npinumber", "phone1"];

    // const { loading, error, isUpdated} = useSelector(state => state.admin);
    const {loading, message, error } = useSelector(state => state.common);
    const { doctors } = useSelector(state => state.doctor);
    const { totalDrs } = useSelector(state => state.adminStat);
    const tableSort = useSortableTable(doctors, { id: 'admin.providers', columns: DOCTOR_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const listSort = tableSort.sortKey ? { sortBy: tableSort.sortKey, sortDir: tableSort.sortDir } : null;
        
    useEffect(() =>{
        if(error){
            alert.error(error);

            dispatch({
                type: HIDE_ALERT_MESSAGE
              })
        }

        if(message) {
            alert.success(message);
            dispatch(getDoctors(resPerPage, currentPage, listSort));
            setSmShow(false);

            dispatch({
                type: HIDE_ALERT_MESSAGE
              })
        }

        dispatch(getDoctors(resPerPage, currentPage, listSort));

    }, [dispatch, error, currentPage, message, tableSort.sortKey, tableSort.sortDir]);

    function setCurrentPageNumber(pageNumber) {
        setCurrentPage(pageNumber);
    } 

    const deActivateDoctor = () => {
        dispatch(doctorDeActivate(doctorModel));
    }

    const activateDoctor = () => {
        dispatch(doctorActivate(doctorModel));
    }

    return (
        <>
                <MetaData title="Providers"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : (
                <>   
                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded-card">
                    <div className="home-content">

                    <div className="row-display">
                            <h5 style={{color: '#004aad'}}>
                                <i className='bx bx-plus-medical'></i> <strong>&nbsp;List of Providers </strong>
                            </h5>

                            <div className="row-display"> 
                                <Link to="/adminDashboard" className="btn btn-secondary btn-sm">
                                    <i className='bx bx-arrow-back'></i></Link> &nbsp;
                                    
                                &nbsp;&nbsp;
                                <Link to="/adddoctor" className="edit-pill">Add New Provider</Link>
                            </div>
                        </div>
                        <hr />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="row-display">    
                                    <input type="text" 
                                        placeholder="Search doctor..." 
                                        className="form-control" 
                                        style={{width: '200px'}}
                                        onChange={e => setQuery(e.target.value)}
                                        onKeyDown={searchOnEnter(setQuery)}
                                    />
                                        &nbsp;&nbsp;&nbsp;

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <br />

                    {/* Patient List Card */}
                        <div className="col-md-12">
                         <>
                         <Table responsive className="table table-sm table-striped">
                            <thead align="center">
                                <tr>
                                    <th>Doctor</th>
                                    <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                    <SortableTh sortKey="gender" sort={tableSort}>Gender</SortableTh>
                                    <SortableTh sortKey="npi" sort={tableSort}>NPI Number</SortableTh>
                                    <SortableTh sortKey="phone" sort={tableSort}>Primary Ph</SortableTh>
                                    <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                    <th>Action</th>
                                </tr> 
                            </thead>
                            <tbody>
                            {tableSort.rows.filter(item => keys.some(key => item[key]?.toLowerCase().includes(query))).map((doctor, index) => ( 
                                <tr key={index}>
                                <td>
                                    {doctor?.profileImg ? <div>
                                        <ProtectedImg fileName={doctor?.profileImg} 
                                        width="50" height="50" className="roundedBorderImg" />
                                    </div> :  
                                    <div>
                                        <img src={adminImg} width="50" height="50" className="roundedBorderImg" />
                                    </div>
                                    }    
                                </td>        
                                <td><Link className="link" to={{ pathname: "/doctorProfile", state: {id: doctor?._id}}}>{formatClinicianName(doctor)} </Link></td>
                                
                                {doctor?.gender === 'male' ? <td>
                                    Male
                                    </td> : 
                                    <td>Female
                                </td>}

                                <td>{doctor?.npinumber ? doctor?.npinumber : '--'}</td>
                                
                                <td>{doctor?.phone1 ? doctor?.phone1 : '--'}</td>
                                
                                <td>
                                   {doctor?.block === false ? <span style={{color: 'green', fontWeight: 'bold'}}>Active</span> : <span style={{color: 'red', fontWeight: 'bold'}}>Deactivated</span>}
                                </td>
                                
                                {/* Actions Dropdown */}
                                <td>
                                        <DropdownButton id="dropdown-basic-button" variant="Light">
                                            <Dropdown.Item>
                                                <Link to={{ pathname: "/doctorProfile", state: {id: doctor?._id}}} className="link">View Profile</Link>
                                            </Dropdown.Item>

                                            <Dropdown.Item>
                                                <Link to={{ pathname: "/Doctor/Edit", state: {id: doctor}}} className="link">Edit Details</Link>
                                            </Dropdown.Item>

                                            <Dropdown.Item>
                                                {doctor?.block === false ? <Link to="/doctors" style={{color: 'red'}} className="link" onClick={() => {setSmShow(true); setDoctorModel(doctor?._id); setDoctorIsBlocked(false); setDoctorToDelete(formatClinicianName(doctor))}}>Deactivate Profile</Link> : 
                                                <Link to="/doctors" className="link" style={{color: 'green'}} onClick={() => {setSmShow(true); setDoctorModel(doctor?._id); setDoctorIsBlocked(true); setDoctorToDelete(formatClinicianName(doctor))}}>Reactivate Profile</Link> }
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </td>
                                {/* Actions Dropdown ends*/}
                            </tr> 
                             ))} 
                            
                             
                             </tbody>
                            </Table> 
                            <small style={{color: 'gray'}}>Showing {resPerPage} records per page</small> 


                            {/* Pagination */}
                                {resPerPage <= totalDrs && (
                                    <div className="d-flex justify-content-center mt-5"> 
                                    <Pagination activePage={currentPage} 
                                    itemsCountPerPage={resPerPage} 
                                    totalItemsCount = {totalDrs}
                                    onChange={setCurrentPageNumber} 
                                    nextPageText = {'⟩'}
                                    prevPageText = {'⟨'}
                                    firstPageText = {'«'}
                                    lastPageText = {'»'}
                                    itemClass='page-item'
                                    linkClass="page-link"
                                    />           
                            </div>
                                )}   
                        </>                      
                        </div>
                    </div>
                </>
             )}
            </section>

            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Body>
                    <small style={{color: 'gray'}}>{doctorIsBlocked ? 'Reactivate this profile' : 'Deactivate this profile'}
                        <span style={{color: '#000'}}> ({doctorToDelete})</span>? {doctorIsBlocked ? 'The person will be able to log in again.' : 'The person will no longer be able to log in.'}
                    </small>
                </Modal.Body>

                <Modal.Footer>
                    {doctorIsBlocked
                        ? <button className="btn btn-sm btn-success" onClick={activateDoctor}>Reactivate Profile</button>
                        : <button className="btn btn-sm btn-danger" onClick={deActivateDoctor}>Deactivate Profile</button>}
                </Modal.Footer>
            </Modal>  
        </>
    )
}

export default DoctorsList;
